/**
 * The suspend save (04 §10): quitting mid-mission suspends, it never rewinds. The world is
 * plain JSON, so a suspended mission is the deployment (which regenerates the map) plus the
 * world as it stood, with the few facts the summary keeps outside it. The mission ending deletes it.
 */

import type { Deployment } from '../meta/api';
import { browserStorage } from '../platform/storage';
import type { Suspended } from './missionApp';

const KEY = 'nightdrop.suspend';
const VERSION = 2;

export interface SuspendSave extends Suspended {
  version: number;
  deployment: Deployment;
}

export function saveSuspend(deployment: Deployment, mission: Suspended): void {
  const save: SuspendSave = { version: VERSION, deployment, world: mission.world, facts: mission.facts };
  browserStorage.save(KEY, JSON.stringify(save));
}

export function clearSuspend(): void {
  browserStorage.save(KEY, '');
}

/** The suspended mission, or null when there is none or it cannot be read. */
export function loadSuspend(): SuspendSave | null {
  const raw = browserStorage.load(KEY);
  if (!raw) return null;
  try {
    const save = JSON.parse(raw) as Partial<SuspendSave>;
    if (save.version !== VERSION || !save.deployment || !save.world || !save.facts) return null;
    return { version: VERSION, deployment: save.deployment, world: save.world, facts: save.facts };
  } catch {
    return null;
  }
}
